export const routes = [
  { path: '/configuracion/impresion', label: 'Configuración de impresión' },
  { path: '/chat', label: 'Chat interno' },
  { path: '/atencion/tickets', label: 'Atención - Tickets' },
  { path: '/atencion/sla', label: 'Atención - SLA' },
  { path: '/atencion/dashboard', label: 'Atención - Dashboard' },
  { path: '/portal/login', label: 'Portal Clientes - Login' },
  { path: '/portal/envios', label: 'Portal Clientes - Envíos' },
  { path: '/portal/tickets/nuevo', label: 'Portal Clientes - Nuevo Ticket' },
  { path: '/portal/tickets/detalle', label: 'Portal Clientes - Ticket' },
  { path: '/cargas', label: 'Cargas' },
  { path: '/cargas/dashboard', label: 'Dashboard de Cargas' },
  { path: '/cargas/retornables', label: 'Retornables Monitor' },
  { path: '/cargas/documentacion-por-bolsa', label: 'Documentación por Bolsa' },
  { path: '/tablas/descripcion-de-envases', label: 'Descripción de Envases' },
  { path: '/cargas/facturar-un-envio-de-contado', label: 'Facturar Un Envío de Contado' },
  { path: '/cargas/revalorizacion-de-envios', label: 'Revalorización de Envíos' },
  { path: '/cargas/consulta-y-reimpresion-de-fc', label: 'Consulta y Reimpresión de FC' },
  { path: '/cargas/envios-de-contado-sin-factura', label: 'Envíos de Contado Sin Factura' },
  { path: '/cargas/ordenes-de-retiros-y-servicios', label: 'Ordenes De Retiros & Servicios' },
  { path: '/cargas/stickers-de-recepcion-de-carga', label: 'Stickers de Recepción de Carga' },
  { path: '/cargas/ingreso-de-remitos', label: 'Ingreso de Remitos' },
  { path: '/cargas/confirmacion-de-despachos', label: 'Confirmación de Despachos' },
  { path: '/cargas/recanalizador-de-carga', label: 'Recanalizador de Carga' },
  { path: '/cargas/fojas-de-ruta', label: 'Fojas de Ruta' },
  { path: '/cargas/control-fiscal-de-ruta-dgr', label: 'Control Fiscal de Ruta - DGR' },
  { path: '/cargas/stickers-por-carta-de-porte', label: 'Stickers por Carta de Porte' },
  { path: '/cargas/transcripcion-guia-de-sucursal', label: 'Transcripción Guía de Sucursal' },
  { path: '/cargas/ingreso-de-remitos-de-sucursal', label: 'Ingreso de Remitos de Sucursal' },
  { path: '/cargas/presupuestador-de-envios', label: 'Presupuestador de Envíos' },
  { path: '/cargas/definicion-de-lineas', label: 'Definición de Líneas' },
  { path: '/cargas/bolsines-por-cliente', label: 'Bolsines por Cliente' },
  { path: '/cargas/auditoria-de-despachos', label: 'Auditoría de Despachos' },
  { path: '/cargas/carga-masiva-de-guias', label: 'Carga Masiva de Guías' },
  { path: '/cargas/importacion-masiva-de-guias', label: 'Importación Masiva de Guías' },
  { path: '/cargas/novedades', label: 'Novedades' },
  { path: '/cargas/retenidas', label: 'Carga Retenida' },
  { path: '/cargas/correccion-novedades', label: 'Corrección de Novedades' },
  { path: '/cargas/novedades/entregas-conforme-en-gral', label: 'Entregas Conforme en Gral' },
  { path: '/cargas/novedades/falta-recepcion-de-remito', label: 'Falta Recepción de Remito' },
  { path: '/cargas/novedades/envio-extraviado', label: 'Envío Extraviado' },
  { path: '/cargas/novedades/guia-sin-entregar-carga-retenida', label: 'Guía sin Entregar (Carga Retenida)' },
  { path: '/cargas/novedades/envio-c-problemas', label: 'Envío c/ Problemas' },
  { path: '/cargas/novedades/no-recibido-en-destino', label: 'No Recibido en Destino' },
  { path: '/cargas/novedades/remito-cancelado', label: 'Remito Cancelado' },
  { path: '/cargas/novedades/remito-rechazado', label: 'Remito Rechazado' },
  { path: '/cargas/novedades/cambio-de-destino', label: 'Cambio de Destino' },
  { path: '/cargas/novedades/cambio-de-pagador', label: 'Cambio de Pagador' },
  { path: '/cargas/novedades/cambio-de-condicion-de-pago', label: 'Cambio de Condición de Pago' },
  { path: '/cargas/novedades/cambio-de-domicilio', label: 'Cambio de Domicilio' },
  { path: '/cargas/novedades/cambio-de-destinatario', label: 'Cambio de Destinatario' },
  { path: '/cargas/novedades/cambio-de-remitente', label: 'Cambio de Remitente' },
  { path: '/clientes', label: 'Clientes' },
  { path: '/clientes/nuevo', label: 'Nuevo Cliente' },
  { path: '/clientes/:id/cuenta-corriente', label: 'Cuenta Corriente Cliente' },
  { path: '/clientes/:id/credito', label: 'Crédito Cliente' },
  { path: '/finanzas/creditos', label: 'Créditos' },
  { path: '/retiros', label: 'Retiros' },
  { path: '/guias', label: 'Listado de Guías' },
  { path: '/guias/consulta', label: 'Consulta de Guías' },
  { path: '/guias/emitir', label: 'Emisión de Guía' },
  { path: '/guias/buscar', label: 'Buscar Guías' },
  { path: '/guias/:id', label: 'Detalle de Guía' },
  { path: '/guias/:id/valorizar', label: 'Valorización de Guía' },
  { path: '/tarifas', label: 'Tarifas' },
  { path: '/cobranzas', label: 'Cobranzas' },
  { path: '/cobranzas/minuta/abrir', label: 'Abrir Minuta de Cobranza' },
  { path: '/cobranzas/minuta/:id', label: 'Minuta de Cobranza' },
  { path: '/cobranzas/minuta/:id/cerrar', label: 'Cerrar Minuta de Cobranza' },
  { path: '/fojas/emision', label: 'Emisión de Foja de Ruta' },
  { path: '/fojas/recepcion/:id', label: 'Recepción de Foja de Ruta' },
  { path: '/etiquetas/nueva', label: 'Nueva Etiqueta' },
  { path: '/etiquetas', label: 'Listar Etiquetas' },
  { path: '/cargas/etiquetas/nueva', label: 'Nueva Etiqueta (Cargas)' },
  { path: '/cargas/etiquetas', label: 'Listado de Etiquetas (Cargas)' },
  { path: '/cargas/recepcion', label: 'Recepción de Cargas' },
  { path: '/cargas/recepcion/nueva', label: 'Nueva Recepción' },
  { path: '/cargas/control-carga', label: 'Control de Carga Confirmada' },
  { path: '/cargas/control-bultos', label: 'Control de bultos' },
  { path: '/cargas/recepcion/:id', label: 'Detalle de Recepción' },
  { path: '/administracion/etiquetas-zpl', label: 'Templates ZPL' },
  { path: '/q/etq/:numero', label: 'Tracking Etiqueta' },
  { path: '/lineas/nueva', label: 'Crear Línea' },
  { path: '/lineas', label: 'Listar Líneas' },
  { path: '/hdr/emitir', label: 'Emitir Hoja de Ruta' },
  { path: '/hdr', label: 'Listar Hojas de Ruta' },
  { path: '/hdr/confirmar', label: 'Confirmar Hoja de Ruta' },
  { path: '/repartos', label: 'Repartos' },
  { path: '/repartos/nuevo', label: 'Nuevo reparto' },
  { path: '/repartos/estadisticas', label: 'Estadísticas de repartos' },
  { path: '/repartos/:id', label: 'Detalle de reparto' },
  { path: '/cargas/repartos', label: 'Repartos' },
  { path: '/cargas/repartos/nuevo', label: 'Nuevo reparto' },
  { path: '/cargas/repartos/:id', label: 'Detalle de reparto' },
  { path: '/tesoreria', label: 'Tesorería' },
  { path: '/tesoreria/dashboard', label: 'Dashboard de Tesorería' },
  { path: '/facturacion', label: 'Facturación' },
  { path: '/facturacion/desde-guias', label: 'Facturación desde Guías' },
  { path: '/facturacion/nueva', label: 'Nueva Factura' },
  { path: '/facturacion/:id', label: 'Detalle de Factura' },
  { path: '/facturacion/facturas/emitir', label: 'Emitir Factura' },
  { path: '/facturacion/manual', label: 'Factura Manual' },
  { path: '/facturacion/manual/nueva', label: 'Factura Manual' },
  { path: '/facturacion/facturas', label: 'Comprobantes Emitidos' },
  { path: '/facturacion/notas-credito', label: 'Notas de Crédito' },
  { path: '/facturacion/configuracion', label: 'Configuración Fiscal' },
  { path: '/ctasctes/cuenta-corriente-clientes/resumen-de-cuenta', label: 'Resumen de Cuenta de Clientes' },
  { path: '/ctasctes/cuenta-corriente-clientes/deuda-de-clientes', label: 'Deuda de Clientes' },
  { path: '/ctasctes/cuenta-corriente-clientes/consulta-creditos-y-debitos', label: 'Consulta Créditos y Débitos Clientes' },
  { path: '/ctasctes/cuenta-corriente-clientes/consolidacion-de-cuentas', label: 'Consolidación de Cuentas' },
  { path: '/ctasctes/cuenta-corriente-clientes/ajustes-de-saldo', label: 'Ajustes de Saldo para Clientes' },
  { path: '/ctasctes/facturacion-y-fiscal/informe-remitos-por-factura', label: 'Informe de Remitos por Factura' },
  { path: '/ctasctes/facturacion-y-fiscal/impresion-masiva-de-envios', label: 'Impresión Masiva de Envíos' },
  {
    path: '/ctasctes/facturacion-y-fiscal/control-previo-a-liquidar-al-cliente',
    label: 'Control Previo a Liquidar al Cliente',
  },
  { path: '/ctasctes/facturacion-y-fiscal/despachos-por-cliente', label: 'Despachos por Cliente' },
  { path: '/ctasctes/facturacion-y-fiscal/subdiario-iva-ventas', label: 'Subdiario IVA Ventas' },
  { path: '/ctasctes/facturacion-y-fiscal/exportacion-arca', label: 'Exportacion ARCA' },
  { path: '/ctasctes/facturacion-y-fiscal/informe-ibcm', label: 'Informe para IBCM' },
  { path: '/ctasctes/facturacion-y-fiscal/percepciones-emitidas', label: 'Percepciones Emitidas' },
  {
    path: '/ctasctes/facturacion-y-fiscal/percepciones-retenciones-agip',
    label: 'Percepciones y Retenciones AGIP',
  },
  {
    path: '/ctasctes/facturacion-y-fiscal/retenciones-percepciones-mendoza',
    label: 'Retenciones y Percepciones Mendoza',
  },
  {
    path: '/ctasctes/facturacion-y-fiscal/regimen-compras-ventas-rg-3685',
    label: 'Régimen Compras y Ventas - RG 3685',
  },
  {
    path: '/ctasctes/contrareembolsos-y-retornables/contrareembolsos-por-viajes',
    label: 'Contrareembolsos por Viajes',
  },
  {
    path: '/ctasctes/contrareembolsos-y-retornables/consulta-retornables-por-viaje',
    label: 'Consulta de Retornables por Viaje',
  },
  {
    path: '/ctasctes/contrareembolsos-y-retornables/documentacion-devoluciones-por-servicios',
    label: 'Documentación y Devoluciones por Servicios',
  },
  { path: '/ctasctes/cruces-y-ajustes/cruces-de-facturacion', label: 'Cruces de Facturación' },
  { path: '/ctasctes/cruces-y-ajustes/consulta-de-cruces-emitidos', label: 'Consulta de Cruces Emitidos' },
  { path: '/ctasctes/cruces-y-ajustes/facturar-diferencias-del-cruce', label: 'Facturar Diferencias del Cruce' },
  { path: '/ctasctes/cruces-y-ajustes/emitir-ajustes-credito-segun-cruce', label: 'Emitir Ajustes Crédito según Cruce' },
  { path: '/ctasctes/cruces-y-ajustes/emitir-ajustes-debito-segun-cruce', label: 'Emitir Ajustes Débito según Cruce' },
  {
    path: '/ctasctes/revalorizaciones/revalorizacion-masiva-viajes-cliente',
    label: 'Revalorización Masiva de Viajes Cliente',
  },
  {
    path: '/ctasctes/revalorizaciones/revalorizacion-viajes-cerrados',
    label: 'Revalorización de Viajes Cerrados',
  },
  {
    path: '/ctasctes/revalorizaciones/revalorizacion-masiva-viajes-chofer',
    label: 'Revalorización Masiva de Viajes Chofer',
  },
  {
    path: '/ctasctes/revalorizaciones/revalorizacion-masiva-unidades-contratadas',
    label: 'Revalorización Masiva de Unidades Contratadas',
  },
  { path: '/ctasctes/reportes/analitico-de-deuda-clientes', label: 'Analítico de Deuda Clientes' },
  { path: '/ctasctes/reportes/saldos-historicos-de-clientes', label: 'Saldos Históricos de Clientes' },
  // Administración - Proveedores
  { path: '/admin/proveedores', label: 'Proveedores (Admin)' },
  { path: '/admin/proveedores/nuevo', label: 'Nuevo Proveedor (Admin)' },
  { path: '/admin/proveedores/:id', label: 'Editar Proveedor (Admin)' },

  // Tesorería - Compras
  { path: '/tesoreria/compras', label: 'Compras' },
  { path: '/tesoreria/compras/nueva', label: 'Nueva compra' },
  { path: '/tesoreria/compras/carga-masiva', label: 'Carga masiva de facturas' },
  { path: '/tesoreria/compras/:id', label: 'Detalle de compra' },
  { path: '/tesoreria/cobranzas', label: 'Cobranzas' },
  { path: '/tesoreria/cobranzas/nueva', label: 'Registrar Cobranza' },
  { path: '/tesoreria/recibos', label: 'Recibos' },
  { path: '/tesoreria/recibos/:id', label: 'Detalle de recibo' },
  { path: '/tesoreria/cobranzas/determinar-recibos-por-cobranzas', label: 'Determinar Recibos por Cobranzas' },
  { path: '/tesoreria/cobranzas/rendicion-de-cobranzas', label: 'Rendición de Cobranzas' },
  { path: '/tesoreria/cobranzas/ingreso-de-recibos', label: 'Ingreso de Recibos' },
  { path: '/tesoreria/cobranzas/depositos-de-cobranzas-en-efectivo', label: 'Depósitos de Cobranzas en Efectivo' },
  { path: '/tesoreria/cobranzas/seguimiento-de-contrareembolsos-cobrados', label: 'Seguimiento de Contrareembolsos Cobrados' },
  { path: '/tesoreria/contrareembolsos/:id', label: 'Detalle de Contrareembolso' },
  { path: '/tesoreria/minutas', label: 'Minutas de Cobranza' },
  { path: '/tesoreria/minutas/:id', label: 'Detalle de Minuta de Cobranza' },
  { path: '/tesoreria/pagos/programar', label: 'Programar Pago' },
  { path: '/tesoreria/pagos', label: 'Historial de Pagos' },
  { path: '/tesoreria/cuentas-pagar', label: 'Cuentas a Pagar' },
  { path: '/tesoreria/minutas-pago', label: 'Minutas de Pago' },
  { path: '/tesoreria/caja/manejo-de-cajas', label: 'Manejo de Cajas' },
  { path: '/tesoreria/caja/ingresos-y-egresos-de-caja', label: 'Ingresos y Egresos de Caja' },
  { path: '/tesoreria/caja/informes-de-caja-habituales', label: 'Informes de Caja Habituales' },
  { path: '/tesoreria/caja/control-de-cajas', label: 'Control de Cajas' },
  { path: '/tesoreria/caja/stock-de-comprobantes', label: 'Stock de Comprobantes' },
  { path: '/tesoreria/proveedores-y-pagos/consulta-debitos-y-creditos-acreedores', label: 'Consulta Débitos y Créditos Acreedores' },
  { path: '/tesoreria/proveedores-y-pagos/ajustes-de-saldos-para-proveedores', label: 'Ajustes de Saldos para Proveedores' },
  { path: '/tesoreria/proveedores-y-pagos/minutas-de-pago', label: 'Minutas de Pago' },
  { path: '/tesoreria/proveedores-y-pagos/resumen-de-cuenta-de-acreedores', label: 'Resumen de Cuenta de Acreedores' },
  { path: '/tesoreria/proveedores-y-pagos/analisis-de-deuda-proveedores', label: 'Análisis de Deuda Proveedores' },
  { path: '/tesoreria/proveedores-y-pagos/cheques-de-terceros', label: 'Cheques de Terceros' },
  { path: '/tesoreria/proveedores-y-pagos/stock-de-chequeras-propias', label: 'Stock de Chequeras Propias' },
  { path: '/tesoreria/impuestos/libro-iva-compras', label: 'Libro IVA Compras' },
  { path: '/tesoreria/impuestos/retenciones-emitidas-por-pagos', label: 'Retenciones Emitidas por Pagos' },
  { path: '/tesoreria/bancos-y-conciliacion/movimientos-bancarios', label: 'Cuentas Bancarias' },
  { path: '/tesoreria/bancos-y-conciliacion/maestro-de-monedas', label: 'Maestro de Monedas' },
  { path: '/tesoreria/conciliaciones', label: 'Conciliación Bancaria' },
  { path: '/tesoreria/reportes', label: 'Reportes de Tesorería' },

  { path: '/contabilidad', label: 'Contabilidad' },
  { path: '/contabilidad/cuentas', label: 'Plan de Cuentas' },
  { path: '/contabilidad/centros', label: 'Centros de Costo' },
  { path: '/contabilidad/asientos', label: 'Asientos Contables' },
  { path: '/contabilidad/politicas', label: 'Políticas de Imputación' },
  { path: '/contabilidad/reportes', label: 'Reportes Contables' },

  { path: '/compras/proveedores', label: 'Compras - Proveedores' },
  { path: '/compras/ordenes', label: 'Compras - Órdenes' },
  { path: '/compras/recepciones', label: 'Compras - Recepciones' },

  { path: '/gerencial', label: 'Gerencial' },
  { path: '/gerencial/dashboard', label: 'Dashboard Gerencial' },
  { path: '/finanzas/ejecutivo', label: 'Panel Ejecutivo' },
  { path: '/gerencial/alertas', label: 'Alertas Gerenciales' },
  { path: '/operaciones/alertas', label: 'Alertas Operaciones' },
  { path: '/operaciones/inteligencia', label: 'Inteligencia Operativa' },
  { path: '/operaciones/inteligencia/configuracion', label: 'Configuración de Inteligencia Operativa' },
  { path: '/monitor/operaciones', label: 'Monitor Operaciones' },
  { path: '/gerencial/reportes', label: 'Reportes Gerenciales' },
  { path: '/gerencial/configuracion/fojas', label: 'Políticas Operativas de Fojas' },
  { path: '/gerencial/reportes-operativos', label: 'Dashboard Operativo' },
  { path: '/gerencial/alertas-operativas', label: 'Alertas Operativas Priorizadas' },
  { path: '/gerencial/seguridad', label: 'Seguridad Gerencial' },
  { path: '/gerencial/usuarios', label: 'Seguridad - Usuarios' },
  { path: '/gerencial/usuarios/nuevo', label: 'Seguridad - Nuevo usuario' },
  { path: '/gerencial/usuarios/:id', label: 'Seguridad - Editar usuario' },
  { path: '/gerencial/roles', label: 'Seguridad - Roles y permisos' },
  { path: '/gerencial/roles/nuevo', label: 'Seguridad - Nuevo rol' },
  { path: '/gerencial/roles/:id', label: 'Seguridad - Editar rol' },
  { path: '/gerencial/sesiones', label: 'Seguridad - Sesiones' },
  { path: '/gerencial/auditoria', label: 'Seguridad - Auditoría' },
  { path: '/rrhh', label: 'RRHH' },
  { path: '/rrhh/empleados', label: 'Empleados' },
  { path: '/rrhh/empleados/nuevo', label: 'Nuevo Empleado' },
  { path: '/rrhh/empleados/:id/editar', label: 'Editar Empleado' },
  { path: '/rrhh/asistencias', label: 'Asistencias' },
  { path: '/rrhh/asistencias/nueva', label: 'Registrar asistencia' },
  { path: '/rrhh/asistencias/:id/editar', label: 'Editar asistencia' },
  { path: '/rrhh/turnos', label: 'Turnos' },
  { path: '/rrhh/turnos/nuevo', label: 'Nuevo turno' },
  { path: '/rrhh/turnos/:id/editar', label: 'Editar turno' },
  { path: '/rrhh/turnos/asignaciones/nueva', label: 'Nueva asignación de turno' },
  { path: '/rrhh/turnos/asignaciones/:id/editar', label: 'Editar asignación de turno' },
  { path: '/rrhh/vacaciones', label: 'Vacaciones' },
  { path: '/rrhh/vacaciones/nueva', label: 'Nueva solicitud de vacaciones' },
  { path: '/rrhh/vacaciones/:id/editar', label: 'Editar solicitud de vacaciones' },
  { path: '/rrhh/legajos', label: 'Listado de Legajos' },
  { path: '/rrhh/altas-bajas', label: 'Altas y Bajas' },
  { path: '/rrhh/parametros', label: 'Parámetros RRHH' },
  { path: '/stock', label: 'Stock' },
  { path: '/stock/dashboard', label: 'Stock - Dashboard' },
  { path: '/stock/movimientos', label: 'Movimientos de Stock' },
  { path: '/stock/inventarios', label: 'Inventarios físicos' },
  { path: '/stock/kardex', label: 'Kardex' },
  { path: '/stock/depositos', label: 'Depósitos' },
  { path: '/stock/transferencias', label: 'Transferencias' },
  { path: '/stock/consulta', label: 'Consulta de stock' },
  { path: '/stock/entradas/nueva', label: 'Nueva entrada de stock' },
  { path: '/stock/entradas', label: 'Entradas de stock' },
  { path: '/stock/salidas/nueva', label: 'Nueva salida de stock' },
  { path: '/stock/salidas', label: 'Salidas de stock' },
  { path: '/stock/traslados/nuevo', label: 'Nuevo traslado de stock' },
  { path: '/mantenimiento-flota', label: 'Mantenimiento de Flota' },
  { path: '/mantenimiento-flota/nuevo', label: 'Nuevo mantenimiento de flota' },
  { path: '/mantenimiento-flota/:id/editar', label: 'Editar mantenimiento de flota' },
  { path: '/mflota', label: 'M. Flota' },
  { path: '/mflota/mantenimiento', label: 'Calendario de Mantenimiento' },
  { path: '/mflota/ordenes', label: 'Órdenes de Taller' },
  { path: '/mflota/telemetria', label: 'Telemetría' },
  { path: '/admin', label: 'Administración' },
  { path: '/admin/clientes', label: 'Clientes (Admin)' },
  { path: '/admin/clientes/nuevo', label: 'Nuevo Cliente (Admin)' },
  { path: '/admin/clientes/:id', label: 'Editar Cliente (Admin)' },
  { path: '/admin/vehiculos', label: 'Vehículos (Admin)' },
  { path: '/admin/vehiculos/nuevo', label: 'Alta de vehículo (Admin)' },
  { path: '/administracion', label: 'Administración' },
  { path: '/administracion/clientes', label: 'Clientes' },
  { path: '/administracion/vehiculos', label: 'Vehículos' },
  { path: '/administracion/vehiculos/nuevo', label: 'Alta de vehículo' },
  { path: '/administracion/vehiculos/:id', label: 'Detalle de vehículo' },
  { path: '/administracion/vehiculos/:id/editar', label: 'Editar vehículo' },
  { path: '/administracion/flota', label: 'Flota' },
  { path: '/administracion/unidades', label: 'Unidades' },
  { path: '/administracion/flota/nuevo', label: 'Nueva unidad de flota' },
  { path: '/administracion/flota/:id/editar', label: 'Editar unidad de flota' },
  { path: '/administracion/flota/asignaciones', label: 'Asignaciones de flota' },
  { path: '/administracion/flota/asignaciones/nueva', label: 'Nueva asignación de flota' },
  { path: '/administracion/choferes', label: 'Choferes' },
  { path: '/administracion/choferes/nuevo', label: 'Nuevo chofer' },
  { path: '/administracion/choferes/:id', label: 'Detalle de chofer' },
  { path: '/administracion/choferes/:id/editar', label: 'Editar chofer' },
  { path: '/administracion/usuarios', label: 'Usuarios' },
  { path: '/administracion/maestros/actualizacion-de-cat', label: 'Actualización de CAT' },
  { path: '/administracion/maestros/empresas-de-transportes', label: 'Empresas de transportes' },
  { path: '/administracion/maestros/tipo-de-unidades', label: 'Tipo de unidades' },
  { path: '/administracion/maestros/parametros-para-las-unidades', label: 'Parámetros para las unidades' },
  { path: '/administracion/maestros/transportes-para-redespachos', label: 'Transportes para redespachos' },
  { path: '/administracion/redespachos', label: 'Empresas de redespacho' },
  { path: '/administracion/redespachos/nuevo', label: 'Nueva empresa de redespacho' },
  { path: '/administracion/redespachos/:id', label: 'Editar empresa de redespacho' },
  { path: '/administracion/maestros/descripcion-de-envases', label: 'Descripción de envases' },
  { path: '/administracion/maestros/articulos-para-viajes', label: 'Artículos para viajes' },
  { path: '/administracion/maestros/conceptos-de-gastos-y-anticipos', label: 'Conceptos de gastos y anticipos' },
  {
    path: '/administracion/maestros/gastos-y-anticipos-predefinidos-por-cliente',
    label: 'Gastos y anticipos predefinidos por cliente',
  },
  { path: '/administracion/maestros/retornables', label: 'Retornables' },
  { path: '/administracion/maestros/clientes-eventuales-para-expreso', label: 'Clientes eventuales para expreso' },
  { path: '/administracion/maestros/tipos-de-servicios-de-viajes', label: 'Tipos de servicios de viajes' },
  { path: '/administracion/maestros/alertas-para-clientes', label: 'Alertas para clientes' },
  {
    path: '/administracion/maestros/choferes-y-transportes-inhabilitados',
    label: 'Choferes y transportes inhabilitados',
  },
  { path: '/administracion/maestros/documentos-para-caratula', label: 'Documentos para carátula' },
  { path: '/administracion/maestros/situacion-de-los-choferes', label: 'Situación de los choferes' },
  { path: '/administracion/maestros/unidades-de-medida', label: 'Unidades de medida' },
  { path: '/administracion/maestros/rubros-de-logistica', label: 'Rubros de logística' },
  {
    path: '/administracion/maestros/maestro-de-eventos-de-logistica',
    label: 'Maestro de eventos de logística',
  },
  { path: '/administracion/maestros/conceptos-de-valorizacion', label: 'Conceptos de valorización' },
  { path: '/administracion/maestros/estaciones-de-servicios', label: 'Estaciones de servicios' },
  { path: '/administracion/maestros/tipos-de-combustibles', label: 'Tipos de combustibles' },
  { path: '/administracion/maestros/marcas-de-combustibles', label: 'Marcas de combustibles' },
  { path: '/administracion/maestros/rubros', label: 'Rubros' },
  { path: '/administracion/maestros/motivos-de-inconvenientes', label: 'Motivos de inconvenientes' },
  { path: '/administracion/maestros/dias-no-laborables-feriados', label: 'Días no laborables (Feriados)' },
  { path: '/administracion/maestros/actualizacion-de-vendedores', label: 'Actualización de vendedores' },
  { path: '/administracion/maestros/actualizacion-de-cobradores', label: 'Actualización de cobradores' },
  { path: '/administracion/maestros/estados-de-los-comprobantes', label: 'Estados de los comprobantes' },
  {
    path: '/administracion/maestros/configurar-alertas-y-vencimientos',
    label: 'Configurar alertas y vencimientos',
  },
  { path: '/administracion/maestros/origenes-de-los-prospectos', label: 'Orígenes de los prospectos' },
  { path: '/administracion/maestros/actualizacion-de-recorridos', label: 'Actualización de recorridos' },
  { path: '/administracion/maestros/categorizacion-de-recorridos', label: 'Categorización de recorridos' },
  { path: '/administracion/maestros/zonas-tarifarias', label: 'Zonas tarifarias' },
  { path: '/administracion/maestros/porcentajes-por-zona-de-reparto', label: 'Porcentajes por zona de reparto' },
  { path: '/administracion/maestros/puestos-de-peajes', label: 'Puestos de peajes' },
  { path: '/administracion/maestros/concesionarios-de-peajes', label: 'Concesionarios de peajes' },
  { path: '/administracion/maestros/liquidacion-de-repartos', label: 'Liquidación de repartos' },
  { path: '/administracion/maestros/repartos-y-guias-a-liquidar', label: 'Repartos y guías a liquidar' },
  { path: '/administracion/maestros/reporte-de-guias-liquidadas-por-pdi', label: 'Reporte de guías liquidadas por PDI' },
  { path: '/administracion/geografia/actualizacion-de-localidades', label: 'Actualización de localidades' },
  { path: '/administracion/geografia/provincias', label: 'Provincias' },
  { path: '/administracion/geografia/paises', label: 'Países' },
  { path: '/administracion/geografia/diccionario-de-localidades', label: 'Diccionario de localidades' },
  { path: '/administracion/tarifas/tarifas-para-almacen', label: 'Tarifas para almacén' },
  { path: '/administracion/tarifas/tarifas-por-cliente-y-articulo', label: 'Tarifas por cliente y artículo' },
  { path: '/administracion/tarifas/tarifas-para-clientes', label: 'Tarifas para clientes' },
  { path: '/administracion/tarifas/tarifas-para-choferes-y-fleteros', label: 'Tarifas para choferes y fleteros' },
  {
    path: '/administracion/tarifas/consulta-de-tarifas-clientes-o-fleteros',
    label: 'Consulta de tarifas: clientes o fleteros',
  },
  { path: '/administracion/tarifas/numeradores-tarifarios', label: 'Numeradores tarifarios' },
  { path: '/administracion/flota-y-taller/padron-de-cubiertas', label: 'Padrón de cubiertas' },
  { path: '/administracion/flota-y-taller/articulos-del-panol', label: 'Artículos del pañol' },
  { path: '/administracion/flota-y-taller/tipos-de-mantenimiento', label: 'Tipos de mantenimiento' },
  { path: '/administracion/flota-y-taller/tareas-para-mantenimiento', label: 'Tareas para mantenimiento' },
  {
    path: '/administracion/flota-y-taller/equipos-generales-y-maquinarias',
    label: 'Equipos generales y maquinarias',
  },
  { path: '/administracion/flota-y-taller/marcas-de-articulos-y-cubiertas', label: 'Marcas de artículos y cubiertas' },
  { path: '/administracion/flota-y-taller/modelos-de-articulos-y-cubiertas', label: 'Modelos de artículos y cubiertas' },
  { path: '/administracion/flota-y-taller/tipos-de-cubiertas', label: 'Tipos de cubiertas' },
  { path: '/administracion/flota-y-taller/familias-de-articulos-de-panol', label: 'Familias de artículos de pañol' },
  {
    path: '/administracion/flota-y-taller/tipos-de-novedades-para-unidades',
    label: 'Tipos de novedades para unidades',
  },
  { path: '/administracion/flota-y-taller/definicion-de-continentes', label: 'Definición de continentes' },
  { path: '/administracion/flota-y-taller/ubicaciones-por-deposito', label: 'Ubicaciones por depósito' },
  { path: '/administracion/flota-y-taller/articulos-por-cliente', label: 'Artículos por cliente' },
  { path: '/administracion/bancos-y-valores/bancos', label: 'Bancos' },
  { path: '/administracion/bancos-y-valores/conceptos-bancarios', label: 'Conceptos bancarios' },
  { path: '/administracion/bancos-y-valores/retenciones-y-otros-valores', label: 'Retenciones y otros valores' },
  {
    path: '/administracion/afip-e-impuestos/importar-padron-arba-retenc-percepc',
    label: 'Importar padrón ARBA - retenc/percepc',
  },
  {
    path: '/administracion/afip-e-impuestos/importar-percepciones-ib-mendoza',
    label: 'Importar percepciones IB Mendoza',
  },
  {
    path: '/administracion/afip-e-impuestos/importar-padron-agip-retenc-percepc',
    label: 'Importar padrón AGIP - retenc/percepc',
  },
  {
    path: '/administracion/afip-e-impuestos/actualizar-porcentaje-percepcion-ib-mendoza',
    label: 'Actualizar % de percepción IB Mendoza',
  },
  {
    path: '/administracion/afip-e-impuestos/importacion-de-padron-de-morosos',
    label: 'Importación de padrón de morosos',
  },
  {
    path: '/administracion/afip-e-impuestos/diccionario-de-documentos-afip',
    label: 'Diccionario de documentos AFIP',
  },
  {
    path: '/administracion/afip-e-impuestos/certificados-de-factura-electronica',
    label: 'Certificados de factura electrónica',
  },
  {
    path: '/administracion/afip-e-impuestos/tipos-de-documentos-de-identidad',
    label: 'Tipos de documentos de identidad',
  },
  { path: '/administracion/empresa/sucursales-de-la-empresa', label: 'Sucursales de la empresa' },
  { path: '/administracion/empresa/localidades-atendidas', label: 'Localidades atendidas' },
  { path: '/administracion/empresa/rutas-de-distribucion', label: 'Rutas de distribucion' },
  { path: '/administracion/empresa/plantilla-de-impresion-de-guias', label: 'Plantilla de impresion de guias' },
  { path: '/administracion/empresa/correo-de-facturas', label: 'Correo de facturas' },
  { path: '/administracion/empresa/comprobantes-habilitados', label: 'Comprobantes habilitados' },
  { path: '/administracion/empresa/puntos-de-venta', label: 'Puntos de venta' },
  { path: '/administracion/empresa/numeracion-del-sistema', label: 'Numeración del sistema' },
  { path: '/agencias', label: 'Agencias' },
  { path: '/agencias/liquidaciones', label: 'Liquidaciones de Agencias' },
  { path: '/agencias/convenios', label: 'Convenios' },
  { path: '/agencias/contactos', label: 'Contactos de Agencias' },
  { path: '/informes', label: 'Informes' },
  { path: '/informes/financieros', label: 'Informes Financieros' },
  { path: '/informes/productividad', label: 'Productividad' },
  { path: '/informes/clientes', label: 'Clientes' },
  { path: '/informes/choferes', label: 'Choferes / Flota' },
  { path: '/seguridad', label: 'Seguridad' },
  { path: '/seguridad/usuarios', label: 'Seguridad - Usuarios' },
  { path: '/seguridad/usuarios/nuevo', label: 'Seguridad - Nuevo usuario' },
  { path: '/seguridad/usuarios/:id', label: 'Seguridad - Editar usuario' },
  { path: '/seguridad/roles', label: 'Seguridad - Roles y permisos' },
  { path: '/seguridad/roles/nuevo', label: 'Seguridad - Nuevo rol' },
  { path: '/seguridad/roles/:id', label: 'Seguridad - Editar rol' },
  { path: '/seguridad/sesiones', label: 'Seguridad - Sesiones' },
  { path: '/seguridad/auditoria', label: 'Seguridad - Auditoría' },
];
